import Attrs from '../models/Attrs'
import { getBaseBuilderVersion } from '../helpers/utils'
import type { ChatMessages, Flow, FlowPage } from '../models/types'
import { generateElementSelectors } from '../styles/selectors'

const CONTROLLER = 'components--chat-messages'
export default function renderChatMessages(
  component: ChatMessages,
  attrs: Attrs,
  page: FlowPage,
  flow: Flow,
  editingMode: boolean
): string {
  attrs
    .addController('template')
    .addValueIfExists('template', 'always-rerender', component.always_rerender)
    .addController(CONTROLLER)
    .addAction(`${CONTROLLER}:update->flow#update`)
    .addDOMClass('InputBox', 'text', 'input_box_shape')
    .addValue(CONTROLLER, 'input-type', 'text')
    .addTarget(CONTROLLER, 'text')

  let inputHtml = ''
  const messagesContainerAttrs = new Attrs().addTarget(CONTROLLER, 'messages')

  const builderVersion = getBaseBuilderVersion(flow.builder_version)

  if (!component.use_external_inputs) {
    const submitButtonClasses = generateElementSelectors({
      elementType: 'ChatSubmitButton',
      component,
      page,
      elementTags: ['Button'],
      builderVersion,
    })
    const submitButtonAttrs = new Attrs().addAction(
      'click->components--chat-messages#submitMessage'
    )
    const textInputAttrs = new Attrs()
      .addTarget(CONTROLLER, 'newMessage')
      // Should be using keydown.enter in the data-action properly, but this doesn't seem to work,
      // so we filter for 'Enter' in the submitMessage() controller function.
      .addAction('keydown->components--chat-messages#submitMessage')

    const messageInputClasses = generateElementSelectors({
      elementType: 'ChatMessageInput',
      component,
      page,
      elementTags: ['Input'],
      builderVersion,
    })
    const messageInputContainerClasses = generateElementSelectors({
      elementType: 'ChatMessageInputContainer',
      component,
      page,
      elementTags: ['InputContainer'],
      builderVersion,
    })
    const loadingClasses = generateElementSelectors({
      elementType: 'ChatMessageLoading',
      component,
      page,
      elementTags: ['gif'],
      builderVersion,
    })
    const loadingImage = component.loading_animation
      ? component.loading_animation
      : 'https://ierxexdtyashuotcsjyo.supabase.co/storage/v1/object/public/uploaded_assets/hD1NU4pDpI0SpkDov3f2/7f8e44f2-fdb8-433b-92db-53e977132aa6_45494898679986817.gif'

    inputHtml = `
    <div class="${messageInputContainerClasses.join(' ')}">
      <textarea ${textInputAttrs} class="${messageInputClasses.join(
      ' '
    )}" type="text" placeholder="Type your message here..."></textarea>
      <button ${submitButtonAttrs} class="${submitButtonClasses.join(' ')}">Send</button>
      <img class="${loadingClasses.join(' ')}" src="${loadingImage}" style="display: none;">
    </div>
  `
  }

  let InitialOptionsHTML = ''
  if (component.quick_initial_options) {
    const quickInitialOptionsContainerClasses = generateElementSelectors({
      elementType: 'ChatQuickInitialOptionsContainer',
      component,
      page,
      elementTags: ['QuickInitialOptionsContainer'],
      builderVersion,
    })
    const quickInitialOptionsClasses = generateElementSelectors({
      elementType: 'ChatQuickInitialOptions',
      component,
      page,
      elementTags: ['QuickInitialOptions'],
      builderVersion,
    })
    InitialOptionsHTML = `
      <div class="${quickInitialOptionsContainerClasses.join(' ')}">
        ${component.quick_initial_options
          .map(
            (option) =>
              `<button class="${quickInitialOptionsClasses.join(
                ' '
              )}" data-action="click->components--chat-messages#actionButtonClicked">${option}</button>`
          )
          .join('')}
      </div>
    `
  }

  const messagesContainerClasses = generateElementSelectors({
    elementType: 'ChatMessagesContainer',
    component,
    page,
    elementTags: ['MessagesContainer'],
    builderVersion,
  })

  return `<div ${attrs}>
    <div ${messagesContainerAttrs} class="${messagesContainerClasses.join(' ')}"> 
      <div>Loading...</div>
    </div>
    ${InitialOptionsHTML}
    ${inputHtml}
  </div>`
}
